import { render, staticRenderFns } from "./CompetenceDetail.vue?vue&type=template&id=79ecd736&scoped=true"
import script from "./CompetenceDetail.vue?vue&type=script&lang=js"
export * from "./CompetenceDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetenceDetail.vue?vue&type=style&index=0&id=79ecd736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ecd736",
  null
  
)

export default component.exports